import { StorageHelpers } from "./Helpers";
import store from "../redux/store/store";
import { setToken, setUserToken } from "../redux/slices/authSlice";

export const decodeToken = (token) => {
  if (!token || typeof token !== "string") {
    return null;
  }

  try {
    const parts = token.split(".");
    if (parts.length !== 3) {
      return null;
    }

    const payload = parts[1]
      .replace(/-/g, "+")
      .replace(/_/g, "/")
      .padEnd(Math.ceil(parts[1].length / 4) * 4, "=");
    const decodedPayload = JSON.parse(
      decodeURIComponent(
        atob(payload)
          .split("")
          .map((char) => `%${char.charCodeAt(0).toString(16).padStart(2, "0")}`)
          .join("")
      )
    );
    return decodedPayload;
  } catch (error) {
    console.error("Token decode hatası:", error);
    return null;
  }
};

export const isTokenExpired = (token) => {
  if (!token) {
    return true;
  }

  const decoded = decodeToken(token);
  if (!decoded) {
    return true;
  }

  const exp = decoded.exp;
  if (!exp) {
    return true;
  }

  const currentTime = Math.floor(Date.now() / 1000);

  return currentTime >= exp;
};

export const clearTokens = () => {
  StorageHelpers.removeAuthToken();
  StorageHelpers.removeUserAuthToken();
};

export const validateAuthToken = () => {
  const authToken = StorageHelpers.getAuthToken();
  if (!authToken) {
    return false;
  }

  if (isTokenExpired(authToken)) {
    StorageHelpers.removeAuthToken();
    return false;
  }

  return true;
};

export const isUserTokenValid = (userAuthToken) => {
  if (!userAuthToken) {
    return false;
  }

  const decoded = decodeToken(userAuthToken);
  if (!decoded?.exp) {
    return true;
  }

  return !isTokenExpired(userAuthToken);
};

export const validateUserAuthToken = () => {
  const userAuthToken = StorageHelpers.getUserAuthToken();
  if (!userAuthToken) {
    return false;
  }

  if (!isUserTokenValid(userAuthToken)) {
    StorageHelpers.removeUserAuthToken();
    return false;
  }

  return true;
};

export const getActiveToken = () => {
  const authToken = StorageHelpers.getAuthToken();
  if (authToken && validateAuthToken()) {
    return authToken;
  }

  const userAuthToken = StorageHelpers.getUserAuthToken();
  if (userAuthToken && validateUserAuthToken()) {
    return userAuthToken;
  }

  return null;
};

export const validateActiveToken = () => {
  return getActiveToken() !== null;
};

export const redirectToHome = () => {
  clearTokens();
  try {
    store.dispatch(setToken(null));
    store.dispatch(setUserToken(null));
  } catch (_) {}
  window.location.href = "/";
};
